import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'

import {
    GetDeviceBringUpStateInput,
    GetDeviceBringUpStateOutput,
    GetStoreBringUpStateInput,
    GetStoreBringUpStateOutput,
    GetStoreValidationStateInput,
    GetStoreValidationStateOutput,
    GetDeviceValidationStateInput,
    GetDeviceValidationStateOutput,
    GetChecklistItemStateInput,
    GetChecklistItemStateOutput,
    GetChecklistItemsInput,
    GetChecklistItemsOutput,
    GetAbaScanConfigInput,
    GetAbaScanConfigOutput,
    GetInventoryDetailsInput,
    GetInventoryDetailsOutput,
    GetInventoryItemsInput,
    GetInventoryItemsOutput,
    GetBroadcastsInput,
    GetBroadcastsOutput,
    GetLightMapMeasurementZonesInput,
    GetLightMapMeasurementZonesOutput,
    ListAttachmentsInput,
    ListAttachmentsOutput,
    GetAbaScanJobInput,
    GetAbaScanJobOutput,
    ListAbaScanStationsInput,
    ListAbaScanStationsOutput,
    StartStoreBringUpInput,
    StartStoreBringUpOutput,
    StartStoreDeviceBringUpInput,
    StartStoreDeviceBringUpOutput,
    StartDeviceBringUpInput,
    StartDeviceBringUpOutput,
    StartStoreValidationInput,
    StartStoreValidationOutput,
    GenerateConnectChatTokenInput,
    GenerateConnectChatTokenOutput,
    UploadAttachmentInput,
    UploadAttachmentOutput,
    CreateAbaScanJobInput,
    CreateAbaScanJobOutput,
    CreateAbaScanStationInput,
    CreateAbaScanStationOutput,
    GetAbaScanUploadPartUrlsInput,
    GetAbaScanUploadPartUrlsOutput,
    CompleteAbaScanUploadPartInput,
    CompleteAbaScanUploadPartOutput,
    StartAbaScanProcessingInput,
    StartAbaScanProcessingOutput,
    UpdateDeviceTaskStateInput,
    UpdateDeviceTaskStateOutput,
    UpdateStoreTaskStateInput,
    UpdateStoreTaskStateOutput,
    UpdateStoreDeviceTaskStateInput,
    UpdateStoreDeviceTaskStateOutput,
    UpdateChecklistItemStateInput,
    UpdateChecklistItemStateOutput,
    UpdateItemStatusInput,
    UpdateItemStatusOutput,
    PutLightMapMeasurementZonesInput,
    PutLightMapMeasurementZonesOutput,
    PutLightMapMeasurementInput,
    PutLightMapMeasurementOutput,
    PutScannedSensorsInput,
    PutScannedSensorsOutput,
    TerminateDeviceBringUpInput,
    TerminateDeviceBringUpOutput,
    DeleteAttachmentInput,
    DeleteAttachmentOutput,
    ListRmaReturnableItemsInput,
    ListRmaReturnableItemsOutput,
    ListRmaSubmissionsInput,
    ListRmaSubmissionsOutput,
    CreateRmaSubmissionInput,
    CreateRmaSubmissionOutput,
    DeleteRmaSubmissionInput,
    DeleteRmaSubmissionOutput,
    GetStoreNetworkWiringInput,
    GetStoreNetworkWiringOutput,
    ListPowerSourcesInput,
    ListPowerSourcesOutput,
    CreatePowerSourceInput,
    CreatePowerSourceOutput,
    UpdatePowerSourceInput,
    UpdatePowerSourceOutput,
    DeletePowerSourceInput,
    DeletePowerSourceOutput,
} from '@amzn/coral_com-amazon-ihmguidedbringup'
import { validateRequired } from './listenerUtils'

// ========================================
// READ OPERATIONS (ViewBringUp)
// ========================================

export async function getDeviceBringUpStateListener (message: any): Promise<GetDeviceBringUpStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getDeviceBringUpState(GetDeviceBringUpStateInput.clone(params)).toPromise()
}

export async function getStoreBringUpStateListener (message: any): Promise<GetStoreBringUpStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getStoreBringUpState(GetStoreBringUpStateInput.clone(params)).toPromise()
}

export async function getStoreValidationStateListener (message: any): Promise<GetStoreValidationStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getStoreValidationState(GetStoreValidationStateInput.clone(params)).toPromise()
}

export async function getDeviceValidationStateListener (message: any): Promise<GetDeviceValidationStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getDeviceValidationState(GetDeviceValidationStateInput.clone(params)).toPromise()
}

export async function getChecklistItemStateListener (message: any): Promise<GetChecklistItemStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getChecklistItemState(GetChecklistItemStateInput.clone(params)).toPromise()
}

export async function getChecklistItemsListener (message: any): Promise<GetChecklistItemsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getChecklistItems(GetChecklistItemsInput.clone(params)).toPromise()
}

export async function getAbaScanConfigListener (message: any): Promise<GetAbaScanConfigOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getAbaScanConfig(GetAbaScanConfigInput.clone(params)).toPromise()
}

export async function getInventoryDetailsListener (message: any): Promise<GetInventoryDetailsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getInventoryDetails(GetInventoryDetailsInput.clone(params)).toPromise()
}

export async function getInventoryItemsListener (message: any): Promise<GetInventoryItemsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getInventoryItems(GetInventoryItemsInput.clone(params)).toPromise()
}

export async function getBroadcastsListener (message: any): Promise<GetBroadcastsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getBroadcasts(GetBroadcastsInput.clone(params)).toPromise()
}

export async function getLightMapMeasurementZonesListener (message: any): Promise<GetLightMapMeasurementZonesOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getLightMapMeasurementZones(GetLightMapMeasurementZonesInput.clone(params)).toPromise()
}

export async function listAttachmentsListener (message: any): Promise<ListAttachmentsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listAttachments(ListAttachmentsInput.clone(params)).toPromise()
}

export async function getAbaScanJobListener (message: any): Promise<GetAbaScanJobOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getAbaScanJob(GetAbaScanJobInput.clone(params)).toPromise()
}

export async function listAbaScanStationsListener (message: any): Promise<ListAbaScanStationsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listAbaScanStations(ListAbaScanStationsInput.clone(params)).toPromise()
}

// ========================================
// WRITE OPERATIONS (ManageBringUp)
// ========================================

export async function startStoreBringUpListener (message: any): Promise<StartStoreBringUpOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.startStoreBringUp(StartStoreBringUpInput.clone(params)).toPromise()
}

export async function startStoreDeviceBringUpListener (message: any): Promise<StartStoreDeviceBringUpOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.startStoreDeviceBringUp(StartStoreDeviceBringUpInput.clone(params)).toPromise()
}

export async function startDeviceBringUpListener (message: any): Promise<StartDeviceBringUpOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.startDeviceBringUp(StartDeviceBringUpInput.clone(params)).toPromise()
}

export async function startStoreValidationListener (message: any): Promise<StartStoreValidationOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.startStoreValidation(StartStoreValidationInput.clone(params)).toPromise()
}

export async function generateConnectChatTokenListener (message: any): Promise<GenerateConnectChatTokenOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.generateConnectChatToken(GenerateConnectChatTokenInput.clone(params)).toPromise()
}

export async function uploadAttachmentListener (message: any): Promise<UploadAttachmentOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.uploadAttachment(UploadAttachmentInput.clone(params)).toPromise()
}

export async function createAbaScanJobListener (message: any): Promise<CreateAbaScanJobOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.createAbaScanJob(CreateAbaScanJobInput.clone(params)).toPromise()
}

export async function createAbaScanStationListener (message: any): Promise<CreateAbaScanStationOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.createAbaScanStation(CreateAbaScanStationInput.clone(params)).toPromise()
}

export async function getAbaScanUploadPartUrlsListener (message: any): Promise<GetAbaScanUploadPartUrlsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getAbaScanUploadPartUrls(GetAbaScanUploadPartUrlsInput.clone(params)).toPromise()
}

export async function completeAbaScanUploadPartListener (message: any): Promise<CompleteAbaScanUploadPartOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.completeAbaScanUploadPart(CompleteAbaScanUploadPartInput.clone(params)).toPromise()
}

export async function startAbaScanProcessingListener (message: any): Promise<StartAbaScanProcessingOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.startAbaScanProcessing(StartAbaScanProcessingInput.clone(params)).toPromise()
}

export async function updateDeviceTaskStateListener (message: any): Promise<UpdateDeviceTaskStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.updateDeviceTaskState(UpdateDeviceTaskStateInput.clone(params)).toPromise()
}

export async function updateStoreTaskStateListener (message: any): Promise<UpdateStoreTaskStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.updateStoreTaskState(UpdateStoreTaskStateInput.clone(params)).toPromise()
}

export async function updateStoreDeviceTaskStateListener (message: any): Promise<UpdateStoreDeviceTaskStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.updateStoreDeviceTaskState(UpdateStoreDeviceTaskStateInput.clone(params)).toPromise()
}

export async function updateChecklistItemStateListener (message: any): Promise<UpdateChecklistItemStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.updateChecklistItemState(UpdateChecklistItemStateInput.clone(params)).toPromise()
}

export async function updateItemStatusListener (message: any): Promise<UpdateItemStatusOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.updateItemStatus(UpdateItemStatusInput.clone(params)).toPromise()
}

export async function putLightMapMeasurementZonesListener (message: any): Promise<PutLightMapMeasurementZonesOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.putLightMapMeasurementZones(PutLightMapMeasurementZonesInput.clone(params)).toPromise()
}

export async function putLightMapMeasurementListener (message: any): Promise<PutLightMapMeasurementOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.putLightMapMeasurement(PutLightMapMeasurementInput.clone(params)).toPromise()
}

export async function putScannedSensorsListener (message: any): Promise<PutScannedSensorsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.putScannedSensors(PutScannedSensorsInput.clone(params)).toPromise()
}

export async function terminateDeviceBringUpListener (message: any): Promise<TerminateDeviceBringUpOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.terminateDeviceBringUp(TerminateDeviceBringUpInput.clone(params)).toPromise()
}

export async function deleteAttachmentListener (message: any): Promise<DeleteAttachmentOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.deleteAttachment(DeleteAttachmentInput.clone(params)).toPromise()
}

// ========================================
// RMA OPERATIONS
// ========================================

export async function listRmaReturnableItemsListener (message: any): Promise<ListRmaReturnableItemsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listRmaReturnableItems(ListRmaReturnableItemsInput.clone(params)).toPromise()
}

export async function listRmaSubmissionsListener (message: any): Promise<ListRmaSubmissionsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listRmaSubmissions(ListRmaSubmissionsInput.clone(params)).toPromise()
}

export async function createRmaSubmissionListener (message: any): Promise<CreateRmaSubmissionOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.createRmaSubmission(CreateRmaSubmissionInput.clone(params)).toPromise()
}

export async function deleteRmaSubmissionListener (message: any): Promise<DeleteRmaSubmissionOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.deleteRmaSubmission(DeleteRmaSubmissionInput.clone(params)).toPromise()
}

// includeCutsheet is always sent as a boolean: the client sends a missing value as null, which GuidedBringUp's
// primitive bool rejects (SerializationException).
export async function getStoreNetworkWiringListener (message: any): Promise<GetStoreNetworkWiringOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getStoreNetworkWiring(GetStoreNetworkWiringInput.clone({ ...params, includeCutsheet: params.includeCutsheet === true })).toPromise()
}

export async function listPowerSourcesListener (message: any): Promise<ListPowerSourcesOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listPowerSources(ListPowerSourcesInput.clone(params)).toPromise()
}

export async function createPowerSourceListener (message: any): Promise<CreatePowerSourceOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.createPowerSource(CreatePowerSourceInput.clone(params)).toPromise()
}

export async function updatePowerSourceListener (message: any): Promise<UpdatePowerSourceOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.updatePowerSource(UpdatePowerSourceInput.clone(params)).toPromise()
}

export async function deletePowerSourceListener (message: any): Promise<DeletePowerSourceOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.deletePowerSource(DeletePowerSourceInput.clone(params)).toPromise()
}
